/**
 * 用户模块
 *
 * @Author: Shann
 * @LastEditors: Shann
 * @Date: 2021-03-23 15:20:54
 * @LastEditTime: 2021-04-09 08:55:26
 * @FilePath: \buyer-one\dop-webapp\src\utils\auth.js
 */
import request from "./request";
import Cookie from "./cookie";

class Auth {
    static _primary = null;

    static get primary() {
        return Auth._primary || (Auth._primary = new Auth());
    }

    isLoggedIn() {
        return Cookie.get("fmg.sid") && Cookie.get("fmg.sid").length > 0;
    }

    login(api, payload) {
        return new Promise((resolve, reject) => {
            request
                .post(api, payload)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    logout() {
        Cookie.remove("fmg.sid");
        Cookie.remove("fmg.extra");
    }
}

export default Auth.primary;
